import { styled } from '@pulse-web-ui/theme';

export const HouseFlatContainer = styled.div<{ $marginBottom?: number }>`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 16px;
  row-gap: 16px;
`;
